import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FORGOT_PASSWORD_FORM_DEFAULT_SCHEMA } from './forgot-password-form-default-schema';
import { FormToggleService } from './form-toggle.service';
import { FormValue } from './form-value';
import { LOGIN_FORM_DEFAULT_SCHEMA } from './login-form-default-schema';

@Component({
  selector: 'labs-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.scss'],
  providers: [FormToggleService]
})
export class LoginCardComponent {
  @Input() loginFormSchema = LOGIN_FORM_DEFAULT_SCHEMA;

  @Input() forgotPasswordFormSchema = FORGOT_PASSWORD_FORM_DEFAULT_SCHEMA;

  @Input() isSubmitting = false;

  @Output() submitForm: EventEmitter<FormValue> = new EventEmitter();

  isLogin = true;

  constructor(private formToggleService: FormToggleService) {
    this.formToggleService.isLoginForm.subscribe(
      (isLogin) => (this.isLogin = isLogin)
    );
  }

  handleSubmitForm(formValue: FormValue) {
    this.submitForm.emit(formValue);
  }
}
